<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <div class="row mb-2 ">
              <div class="col-sm-8">
              </div>
              <div class="col-sm-4">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right me-2">
                    <button type="button" class="btn  btn-primary btn-rounded mb-2 mr-2" @click="showFilters()">
                      <i class="mdi mdi-filter mr-1"></i> Filtros
                    </button>
                  </div>
                  <div class="text-sm-right">
                    <button type="button" class="btn  btn-success btn-rounded mb-2 mr-2" @click="exportWordClouds()">
                      <i class="mdi mdi-file-export-outline mr-1"></i> Exportar Dados
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-hover">
                <thead>
                  <tr>
                    <th width="20%">Sala</th>
                    <th width="40%">Pergunta</th>
                    <th width="30%">Palavras</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in askings" :key="list.id">
                    <td>{{ list.room.data.name }}</td>
                    <td>{{ list.description }}</td>
                    <td>
                      <span class="badge badge-soft-primary font-size-11 m-1" v-for="(w, k) in list.words_group" :key="k">
                        {{ '('+w.total+') ' + w.word }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-filter ref="modalFilter" @wordFiltered="getReport"></modal-filter>
  </div>
</template>
<script>
// Import component
import appConfig from '@/app.config'
import serviceReport from '../services'
import modalFilter from '@/components/modals/filters/WordCloudFilter'

export default {
  components: {
    modalFilter
  },
  name: 'report-askings',
  page: {
    title: 'Relatório Nuvem de Palavras',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      params: {},
      totalRows: 1,
      rows: 0,
      currentPage: 1,
      statusLabel: ['Não respondida', 'Respondida', 'Respondida ao vivo'],
      askings: [],
      perPage: 20,
      title: 'Relatório Nuvem de Palavras'
    }
  },
  mounted () {
    let loeader = this.$loading.show()
    serviceReport.listResultWordCloud({ limit: this.perPage }).then((res) => {
      this.askings = res.data
      this.rows = res.meta.pagination.total
      this.currentPage = res.meta.pagination.current_page
      loeader.hide()
    }).catch(error => {
      console.log(error)
      loeader.hide()
    })
    this.totalRows = this.rows
  },
  created () {},
  computed: {
  },
  methods: {
    showFilters () {
      this.$refs.modalFilter.open()
    },
    exportWordClouds () {
      let loeader = this.$loading.show()
      serviceReport.exportResultWordCloud(this.params).then((res) => {
        this.download(res)
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    getReport (filter = '') {
      let loeader = this.$loading.show()
      let params = {
        limit: this.perPage,
        page: this.currentPage,
        room_id: filter.room_id || null,
        word_cloud_id: filter.word_cloud_id || null
      }
      this.params = params
      serviceReport.listResultWordCloud(params).then((res) => {
        this.askings = res.data
        if (res.data.length > 0) {
          this.rows = res.meta.pagination.total
          this.currentPage = res.meta.pagination.current_page
        }
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  watch: {
    currentPage () { this.updateList() },
    total () { this.updateList() },
    dataPerPage () { this.updateList() }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
